import Vue from "vue";
import Vuetify from "vuetify/lib";
import de from "vuetify/src/locale/de";

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {de},
        current: "de",
    },
    theme: {
        themes: {
            light: {
                primary: "#81B219",
                secondary: "#FFF176",
                accent: "#64B5F6",
                error: "#E57373",
                warning: "#FFB74D",
                info: "#4DD0E1",
                success: "#81B219"
            },
        },
    },
    icons: {
        iconfont: "mdi",
    },
});
